import * as React from 'react';

import { DurationField, DurationFieldProps } from 'components/Form';
import { Omit } from 'types';
import SlideOptionsField from './SlideOptionsField';

type Props = Omit<DurationFieldProps, 'label'>;

const SlideStartTimeField: React.SFC<Props> = ({ className, ...props }) => (
  <SlideOptionsField className={className}>
    <DurationField {...props} label="Start Time" />
  </SlideOptionsField>
);

export default SlideStartTimeField;
export { Props as SlideStartTimeFieldProps };
